import * as types from '../constants/actionTypes';

// Fetch Delivery Challans (with filters)
export const fetchDeliveryChallansRequest = (filters = {}) => ({
  type: types.FETCH_DELIVERY_CHALLANS_REQUEST,
  payload: filters,
});

export const fetchDeliveryChallansSuccess = (data) => ({
  type: types.FETCH_DELIVERY_CHALLANS_SUCCESS,
  payload: data,
});

export const fetchDeliveryChallansFailure = (error) => ({
  type: types.FETCH_DELIVERY_CHALLANS_FAILURE,
  payload: error,
});

// Fetch Single Delivery Challan
export const fetchDeliveryChallanRequest = (id) => ({
  type: types.FETCH_DELIVERY_CHALLAN_REQUEST,
  payload: id,
});

export const fetchDeliveryChallanSuccess = (data) => ({
  type: types.FETCH_DELIVERY_CHALLAN_SUCCESS,
  payload: data,
});

export const fetchDeliveryChallanFailure = (error) => ({
  type: types.FETCH_DELIVERY_CHALLAN_FAILURE,
  payload: error,
});

// Create Delivery Challan
export const createDeliveryChallanRequest = (data) => ({
  type: types.CREATE_DELIVERY_CHALLAN_REQUEST,
  payload: data,
});

export const createDeliveryChallanSuccess = (data) => ({
  type: types.CREATE_DELIVERY_CHALLAN_SUCCESS,
  payload: data,
});

export const createDeliveryChallanFailure = (error) => ({
  type: types.CREATE_DELIVERY_CHALLAN_FAILURE,
  payload: error,
});

// Update Delivery Challan
export const updateDeliveryChallanRequest = (id, data) => ({
  type: types.UPDATE_DELIVERY_CHALLAN_REQUEST,
  payload: { id, data },
});

export const updateDeliveryChallanSuccess = (data) => ({
  type: types.UPDATE_DELIVERY_CHALLAN_SUCCESS,
  payload: data,
});

export const updateDeliveryChallanFailure = (error) => ({
  type: types.UPDATE_DELIVERY_CHALLAN_FAILURE,
  payload: error,
});

// Verify Delivery Challan
export const verifyDeliveryChallanRequest = (id, data) => ({
  type: types.VERIFY_DELIVERY_CHALLAN_REQUEST,
  payload: { id, data },
});

export const verifyDeliveryChallanSuccess = (data) => ({
  type: types.VERIFY_DELIVERY_CHALLAN_SUCCESS,
  payload: data,
});

export const verifyDeliveryChallanFailure = (error) => ({
  type: types.VERIFY_DELIVERY_CHALLAN_FAILURE,
  payload: error,
});

// Delete Delivery Challan
export const deleteDeliveryChallanRequest = (id) => ({
  type: types.DELETE_DELIVERY_CHALLAN_REQUEST,
  payload: id,
});

export const deleteDeliveryChallanSuccess = (id) => ({
  type: types.DELETE_DELIVERY_CHALLAN_SUCCESS,
  payload: id,
});

export const deleteDeliveryChallanFailure = (error) => ({
  type: types.DELETE_DELIVERY_CHALLAN_FAILURE,
  payload: error,
});

// Fetch Purchase Order Delivery Status
export const fetchPODeliveryStatusRequest = (poId) => ({
  type: types.FETCH_PO_DELIVERY_STATUS_REQUEST,
  payload: poId,
});

export const fetchPODeliveryStatusSuccess = (data) => ({
  type: types.FETCH_PO_DELIVERY_STATUS_SUCCESS,
  payload: data,
});

export const fetchPODeliveryStatusFailure = (error) => ({
  type: types.FETCH_PO_DELIVERY_STATUS_FAILURE,
  payload: error,
});

// Fetch Delivery Status Summary
export const fetchDeliveryStatusSummaryRequest = (filters = {}) => ({
  type: types.FETCH_DELIVERY_STATUS_SUMMARY_REQUEST,
  payload: filters,
});

export const fetchDeliveryStatusSummarySuccess = (data) => ({
  type: types.FETCH_DELIVERY_STATUS_SUMMARY_SUCCESS,
  payload: data,
});

export const fetchDeliveryStatusSummaryFailure = (error) => ({
  type: types.FETCH_DELIVERY_STATUS_SUMMARY_FAILURE,
  payload: error,
});

// Fetch Delivery Statistics
export const fetchDeliveryStatisticsRequest = () => ({
  type: types.FETCH_DELIVERY_STATISTICS_REQUEST,
});

export const fetchDeliveryStatisticsSuccess = (data) => ({
  type: types.FETCH_DELIVERY_STATISTICS_SUCCESS,
  payload: data,
});

export const fetchDeliveryStatisticsFailure = (error) => ({
  type: types.FETCH_DELIVERY_STATISTICS_FAILURE,
  payload: error,
});

// Fetch Challans for a Purchase Order
export const fetchPOChallansRequest = (poId) => ({
  type: types.FETCH_PO_CHALLANS_REQUEST,
  payload: poId,
});

export const fetchPOChallansSuccess = (data) => ({
  type: types.FETCH_PO_CHALLANS_SUCCESS,
  payload: data,
});

export const fetchPOChallansFailure = (error) => ({
  type: types.FETCH_PO_CHALLANS_FAILURE,
  payload: error,
});

// UI State Management
export const setDeliveryChallanEditing = (challan) => ({
  type: types.SET_DELIVERY_CHALLAN_EDITING,
  payload: challan,
});

export const clearDeliveryChallanEditing = () => ({
  type: types.CLEAR_DELIVERY_CHALLAN_EDITING,
});
